export default class FilteredListFilterRemovedEvent extends CustomEvent<{
  filterKey: string;
}> {
  constructor(detail: {
    filterKey: string;
  }) {
    super('filtered-list-snd-filter-removed', { bubbles: true, detail });
  }
}